<template>
  <div>
    <div class="home">
      <div v-if="error" class="w-100 bg-danger p-3">{{error}}</div>
      <div v-if="show" class="text-center">
        <b-spinner variant="danger" label="Spinning"></b-spinner>
      </div>

      <!-- Search Input Section -->
      <div v-if="!searchResults.length" class="search-container">
        <b-card class="search-card">
          <b-form @submit.prevent="performSearch">
            <b-form-group
              label="Search Suppliers Stock [Abakus and SKV for now]"
              label-for="search-input"
              label-class="search-label">
              <b-form-input
                id="search-input"
                v-model="searchQuery"
                type="text"
                placeholder="Enter OE code"
                size="lg"
                class="search-input">
              </b-form-input>
            </b-form-group>
            <b-button
              type="submit"
              variant="primary"
              size="lg"
              :disabled="!searchQuery.trim()"
              class="search-button">
              Search
            </b-button>
          </b-form>
        </b-card>
      </div>

      <!-- Results Table Section -->
      <div v-if="searchResults.length" class="results-container">
        <b-card>
          <template #header>
            <div class="d-flex justify-content-between align-items-center">
              <span>Search Results ({{searchResults.length}})</span>
              <b-button
                variant="outline-secondary"
                size="sm"
                @click="clearResults">
                New Search
              </b-button>
            </div>
          </template>

          <b-table
            :items="searchResults"
            :fields="tableFields"
            responsive
            striped
            sticky-header="60vh"
            head-variant="dark"
            class="mb-0">

            <template #cell(actions)="row">
              <b-button
                variant="success"
                size="sm"
                @click="orderProduct(row.item)">
                Order <b-icon-truck></b-icon-truck>
              </b-button>
            </template>

            <template #cell(localCount)="row">
              <span class="font-weight-bold">{{row.value || 0}}</span>
            </template>

            <template #cell(localLocation)="row">
              <span class="text-muted">{{row.value || 'No location'}}</span>
            </template>

          </b-table>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import fixed from '@/fixed';

export default {
  data() {
    return {
      error: '',
      show: false,
      searchQuery: '',
      searchResults: [],
      tableFields: [
        { key: 'supplier', label: 'Supplier', sortable: true },
        { key: 'name', label: 'Product Name', sortable: false },
        { key: 'part_number', label: 'Part Number', sortable: false },
        { key: 'stock', label: 'Stock', sortable: true },
        { key: 'actions', label: 'Actions' },
      ],
    };
  },
  methods: {
    async performSearch() {
      const oe = this.removeNonAlphanumeric(this.searchQuery.trim());
      if (!oe) {
        this.$toast.error('Please enter a valid OE code');
        return;
      }

      const uri = `${fixed.API_URL}/admin/suppliers-oe-products?oe=${oe}`;
      this.show = true;
      this.error = '';

      try {
        const response = await axios.get(uri, { withCredentials: true });
        const data = response.data?.data || response.data;

        if (!data || data.length === 0) {
          this.$toast.info('No products found');
          this.searchResults = [];
        } else {
          this.searchResults = data;
          this.$toast.success(`Found ${data.length} product(s)`);
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.error = 'you\'re not authorised for that action ✋🏻';
        } else {
          this.error = error.response?.data || error.message;
        }
        this.searchResults = [];
      }

      this.show = false;
    },

    removeNonAlphanumeric(str) {
      return str.replace(/[^a-zA-Z0-9]/g, '');
    },

    clearResults() {
      this.searchResults = [];
      this.searchQuery = '';
      this.error = '';
    },

    orderProduct(product) {
      this.$toast.info(`Ordering ${product.name} is not implemented yet`);
    },
  },
};
</script>

<style scoped>
.search-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  padding: 2rem;
}

.search-card {
  max-width: 600px;
  width: 100%;
  background-color: #343a40;
  color: aliceblue;
}

.search-label {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.search-input {
  margin-bottom: 1.5rem;
}

.search-button {
  width: 100%;
}

.results-container {
  margin: 2rem -6rem;
}

.card {
  background-color: #343a40;
  color: aliceblue;
}

.card-header {
  font-size: 1.3rem;
}

.home {
  color: #222222;
}
</style>
